// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","header":"ArtifactChangeDetailsPopupHeader__header--Vo","title":"ArtifactChangeDetailsPopupHeader__title--z3"};